const isAssistantBubbleEvent = (event = {}) => {
  if (event?.type !== 'bubble') {
    return false;
  }

  return (
    String(event?.className || '')
      .trim()
      .toLowerCase() !== 'user'
  );
};

export default isAssistantBubbleEvent;
